<template>
    <div>
        <div style="display: flex; ">
            <span class="btn" v-bind:class="{ 'btn-primary': activeFilter === 'today' }" @click="filterToday">
                Today
            </span>
            <span class="btn" v-bind:class="{ 'btn-primary': activeFilter === 'week' }" @click="filterThisWeek">
                This Week
            </span>
            <span class="btn" v-bind:class="{ 'btn-primary': activeFilter === 'month' }" @click="filterThisMonth">
                This Month
            </span>
            <span class="btn" v-bind:class="{ 'btn-primary': activeFilter === 'custom' }" @click="showCustomFilter">
                Custom
            </span>
        </div>
        <div v-show="activeFilter === 'custom'" style="display: flex; flex-direction: row; justify-content: space-between; margin-left: 15px; margin-right: 15px; margin-top: 15px;">

            <input type="date" placeholder="Select Starting Date" v-model="dateFrom" name="trip-start"
                   value="">
            <input type="date"  placeholder="Select End Date" v-model="dateTo" name="trip-start"
                   value="">

            <button class="btn btn-primary" @click="filterCustom">Filter</button>

        </div>

    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: "VueDateFilter",
    props: {
        defaultFilter: {
            type: String,
            required: false,
            default: 'today'
        },
    },
    data() {
        return {
            dates: {
                start: null,
                end: null,
            },
            activeFilter: 'today',
            dateFrom: null,
            dateTo: null,
        }
    },
    watch: {
        dateFrom(date) {
            this.$set(this.dates, 'start', moment(date).startOf('day').unix())
        },
        dateTo(date) {
            this.$set(this.dates, 'end', moment(date).endOf('day').unix())
        }
    },
    created() {
        this.applyDefaultFilter();
    },
    methods: {
        filter(filterType) {
            this.$emit('dateFilterChange', this.dates.start, this.dates.end, filterType)
        },

        filterToday() {
            this.activeFilter = 'today';
            this.$set(this.dates, 'start', moment().startOf('day').unix())
            this.$set(this.dates, 'end', moment().endOf('day').unix())
            this.filter('today');
        },

        filterThisWeek() {
            this.activeFilter = 'week'
            let startOfWeek = moment().startOf('week').isoWeekday(1)
            let endOfWeek = moment(startOfWeek).endOf('week').isoWeekday(7);
            this.$set(this.dates, 'start', startOfWeek.unix());
            this.$set(this.dates, 'end', endOfWeek.unix());
            this.filter('week');
        },

        filterThisMonth() {
            this.activeFilter = 'month'
            this.$set(this.dates, 'start', moment().startOf('month').unix());
            this.$set(this.dates, 'end', moment().endOf('month').unix());
            this.filter('month');
        },

        filterCustom() {
            this.filter('custom')
        },

        showCustomFilter() {
            this.activeFilter = 'custom';
            this.resetDateFilter();
        },
        resetDateFilter() {
            this.dates = {
                start: null,
                end: null
            };
            this.$set(this.dates, 'start', null);
            this.$set(this.dates, 'end', null);
            this.dateFrom = null;
            this.dateTo = null;
        },

        applyDefaultFilter() {
            switch (this.defaultFilter) {
                case 'today':
                    this.filterToday();
                    break;
                case 'week':
                    this.filterThisWeek()
                    break;
                case 'month':
                    this.filterThisMonth();
                default:
                    break;

            }
        }
    }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/generic/VueDateFilter.vue